import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [licenseCode, setLicenseCode] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [platform, setPlatform] = useState('web');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const d = qs.get('deviceId');
    const p = qs.get('platform');
    if (d) setDeviceId(d);
    if (p) setPlatform(p);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, businessName, licenseCode, deviceId, platform })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || 'Registrazione non riuscita');
      } else {
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('businessInfo', JSON.stringify({ name: businessName, logo: null }));
        navigate('/setup/card-layout');
      }
    } catch (e) {
      setError('Errore di rete');
    }
    setLoading(false);
  };

  return (
    <div className="container" style={{ maxWidth: 420 }}>
      <div className="step-container">
        <div className="step-header">
          <h2>Crea account</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="licenseCode">Codice licenza</label>
            <input id="licenseCode" type="text" value={licenseCode} onChange={(e) => setLicenseCode(e.target.value)} required />
          </div>
          <div className="form-group">
            <label htmlFor="businessName">Nome attività</label>
            <input id="businessName" type="text" value={businessName} onChange={(e) => setBusinessName(e.target.value)} required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <p className="message" style={{ color: '#b00020' }}>{error}</p>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Creazione...' : 'Crea account'}
          </button>
          <div style={{ marginTop: 12, textAlign: 'center' }}>
            <Link to="/login">Hai già un account? Accedi</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;


